// eslint-disable-next-line no-use-before-define
import Temporal, { DEFAULT_CHART_CONFIG as TEMPORAL_DEFAULT_CHART_CONFIG } from 'live/widgets/temporal'
import _ from 'lodash'
import { destroy, redraw, reflow } from 'live/widgets/highcharts-prototype'
import serviceLocator from 'live/services/service-locator'
import EventRenderer from './auto-analysis/annotations/event-renderer'
import {
    getAssetChartPrototype,
    AssetChartPrototypeRightActionsEntry
} from 'plugin-assets/shared/widget/multi-channel/getAssetChartPrototype'
import getChannelsAutoAnalysis from 'plugin-assets/shared/auto-analysis/channels-auto-analysis'
import {
    DEFAULT_CHANNELS_CHART_CONFIG,
    DEFAULT_CHANNELS_CHART_POLICIES,
    addWidgetAction
} from 'plugin-assets/shared/widget/lib/util'
import Registry from 'live/services/registry'
import temporalAnalysisApi from './auto-analysis/api'
import getChannelsTemporalTestTools from './automated-test-tools/channels-temporal-test-tools'

const ChannelsTemporalRightActionsService = new Registry<AssetChartPrototypeRightActionsEntry>()

export const widgetType = 'channels-temporal'

addWidgetAction(getChannelsTemporalTestTools(), ChannelsTemporalRightActionsService, widgetType)
addWidgetAction(getChannelsAutoAnalysis(temporalAnalysisApi), ChannelsTemporalRightActionsService, widgetType)

serviceLocator
    .getService('timeline-event-renderer-registry')
    .then(service => service.register(EventRenderer('timeline')))
serviceLocator
    .getService('messenger-event-renderer-registry')
    .then(service => service.register(EventRenderer('messenger')))

serviceLocator.registerService('channels-temporal-right-actions-service', ChannelsTemporalRightActionsService)

class channelsTemporal extends Temporal {}

const onDataEvents = channelsTemporal.prototype.onDataEvents
const initialize = channelsTemporal.prototype.initialize
const updateForField = channelsTemporal.prototype.updateForField
const onStartQuery = channelsTemporal.prototype.onStartQuery
const createSeries = channelsTemporal.prototype.createSeries
const removeOutersAtLeft = channelsTemporal.prototype.removeOutersAtLeft

const flow = channelsTemporal.prototype.flow

_.extend(
    channelsTemporal.prototype,
    destroy,
    redraw,
    reflow,
    getAssetChartPrototype({
        onDataEvents,
        flow,
        initialize,
        createSeries,
        updateForField,
        onStartQuery,
        DEFAULT_CHART_CONFIG: TEMPORAL_DEFAULT_CHART_CONFIG,
        rightActionsRegistry: ChannelsTemporalRightActionsService,
        removeOutersAtLeft
    })
)

export default channelsTemporal

export const defaultChannelsTemporalConfig: Partial<ChannelsWidgetJsonConfig> = {
    ...TEMPORAL_DEFAULT_CHART_CONFIG,
    ...DEFAULT_CHANNELS_CHART_CONFIG,
    kind: widgetType,
    showXGridLines: false
}

export const CHANNEL_TEMPORAL_POLICIES = {
    ...DEFAULT_CHANNELS_CHART_POLICIES
}
